import React from 'react';
import classes from './pdfNotes.module.css';

function PdfNotes(_ref) {
  var note = _ref.note;
  if (!note) return React.createElement(React.Fragment, null);
  return React.createElement("div", {
    className: classes['pdf-notes-wrapper']
  }, React.createElement("p", {
    className: "font-bold mr-5"
  }, "NOTE"), React.createElement("p", null, note));
}

export default PdfNotes;